import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ConfirmationService, MessageService, Message } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { Setting } from 'src/app/core/api/setting';
import { AssignmentsService } from '../../service/assigned/assignments.service';
import { CatalogVehicleType } from '../../api/assignment-employee/catalog';
import { CatalogService } from './../../service/management-catalog/catalog.service';
import { Assignments, GetEmployee } from 'src/app/core/api/assignment/assignment.model';
import { AssignmentLoanService } from 'src/app/core/service/assignment-loan/assignment-loan.service';
import { AuthService } from 'src/app/core/service/auth/auth.service';
import { SettingService } from 'src/app/core/service/setting.service';
import { Component, Input, OnInit } from '@angular/core';



@Component({
    selector: 'app-guest-form',
    standalone: false,
    templateUrl: './guest-form.component.html',
    styleUrl: './guest-form.component.css',
    providers: [ConfirmationService]

})
export class GuestFormComponent implements OnInit {

    // vehicleTypes: string[] = ['CARRO', 'CAMION', 'MOTO'];

    vehicleTypes: string[] = [];
    vehicleCatalog: CatalogVehicleType[];

    year: number;
    startDate: string;
    endDate: string;

    minDate: Date;
    maxDate: Date;
    today: Date;
    maxDateGuest: Date;

    errorMessageSearch: string;
    errorMessageAssignment: string;
    errorFromApi: string;

    assignmentForm: FormGroup;


    employeeForm: FormGroup;

    employeeData: GetEmployee;

    //Para Recibir Id de la ruta
    assignment_id: string

    //CRDU GUEST
    assignments: any[] = [];
    selectedAssignment: any = {};
    displayDialog: boolean = false
    validateEmail: boolean = false;
    settings: Setting[] = [];



    constructor(private fb: FormBuilder, private assignmentLoanService: AssignmentLoanService,
        private confirmationService: ConfirmationService, private messageService: MessageService,
        private employeeService: AssignmentsService,
        private route: ActivatedRoute,
        private router: Router,
        private settingService: SettingService,
        private catalogService: CatalogService,
        private auth: AuthService
    ) {
        this.assignmentForm = this.fb.group({
            //slotId: ['', [Validators.required, Validators.pattern('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')]],
            //parkingCardNumber: ['', Validators.required],
            startDateAssignment: ['', Validators.required],
            endDateAssignment: ['', Validators.required],
            employee: this.fb.group({
                //id: [''],
                employeeCode: [''],
                name: ['', [Validators.required]],
                workplace: [''],
                identifierDocument: [''],
                company: [''],
                department: [''],
                subManagement: [''],
                management1: [''],
                management2: [''],
                workSite: [''],
                address: [''],
                email: [''],
                phone: [''],
                vehicles: this.fb.array([]),
                //vehiclesForDelete: this.fb.array([]),
            })
        });


        //FORM PARA BUSQUEDA
        this.employeeForm = this.fb.group({
            id: ['', [Validators.required, Validators.pattern('^\\d+$')]]
        });

    }

    ngOnInit(): void {
        this.year = new Date().getFullYear();
        this.addVehicle();

        this.getAllVehicles()

        this.assignment_id = this.auth.getAssignmentId() || '';
        //console.log('Assignment ID desde AuthService:', this.assignment_id);

        if (!this.assignment_id) {
            console.error('No se encontró el Assignment ID en localStorage.');
            return;
        }

        // CRUD GUEST
        this.loadAssignments();

        // FECHA INICIO
        this.today = new Date();

        // OBTENER FECHA DE PARÁMETROS
        this.settingService.getSetting().then((data) => {
            this.settings = data;

            //let numericValue = +this.settings[0].settingValue;
             const maxDaysToAssignmentLoanStr = this.settings.find(
                setting => setting.settingKey === 'MAX_DAYS_TO_ASSIGNMENT_LOAN'
                 )?.settingValue;

            const maxDaysToAssignmentLoan = parseInt(maxDaysToAssignmentLoanStr ?? '0', 10);


            //FECHA Asignaciones
            const today = new Date();
            this.minDate = today;
            this.maxDate = new Date();
            this.maxDate.setDate(today.getDate() + maxDaysToAssignmentLoan);

            //Fecha inicio invitado
            this.maxDateGuest = new Date();
            this.maxDateGuest.setDate(this.today.getDate() + maxDaysToAssignmentLoan);
        });
    }


    onSearch() {
        const id = this.employeeForm.get('id')?.value;

        this.employeeService.getEmployeeById(id).subscribe({

            next: (employeeApi: any) => {
                this.employeeData = employeeApi.data;

                if (this.employeeData.employeeHasActiveAssignments === 0 || this.employeeData.employeeHasActiveAssignments === false) {
                    this.assignmentForm.get('employee')?.patchValue({
                        name: this.employeeData.name,
                        employeeCode: this.employeeData.employeeCode,
                        workplace: this.employeeData.workplace,
                        identifierDocument: this.employeeData.identifierDocument,
                        company: this.employeeData.company,
                        department: this.employeeData.department,
                        subManagement: this.employeeData.subManagement,
                        management1: this.employeeData.management1,
                        management2: this.employeeData.management2,
                        workSite: this.employeeData.workSite,
                        address: this.employeeData.address,
                        email: this.employeeData.email,
                        phone: this.employeeData.phone,
                    });

                    if (!this.employeeData.email) {
                        this.validateEmail = true
                        this.messajeError('warn', '¡Alerta!', "El correo es oligatorio para crear la asignación.")
                    } else {
                        this.validateEmail = false
                    }
                }

                if (this.employeeData.employeeHasActiveAssignments === 1 || this.employeeData.employeeHasActiveAssignments === true) {
                    this.messajeError('warn', '¡Alerta!', "El empleado ya cuenta con una asignación.")
                    this.recetAssignmentForm();
                }


                this.errorMessageSearch = '';
                //console.log("DATA API EMPLEADOS ******", this.employeeData)
            },
            error: error => {
                this.errorMessageSearch = error
                this.errorMessageSearch = "El código ingresado no es valido."
                //console.log("ERROR ON SEARCH", this.errorMessageSearch)
                this.recetAssignmentForm();
            }
        })

    }

    //Agrega array nuevo vehiculo
    get vehicles(): FormArray {
        return this.assignmentForm.get('employee.vehicles') as FormArray;
    }

    //Crea nuevo Array de Vehiculos
    addVehicle(): void {
        if (this.vehicles.length < 5) {
            this.vehicles.push(this.fb.group({
                //id: [''],
                vehicleBadge: ['', [Validators.required, Validators.pattern(/^[PCAOM]{1}[0-9]{3}[A-Z]{3}$/)]], // valida placas de GT
                color: [''],
                brand: [''],
                model: ['', [Validators.required, Validators.pattern(/^(19|20)\d{2}$/)]],
                type: ['']
            }));
        } else {
            this.messajeError('warn', '¡Alerta!', "Limite de Vehiculos Alcanzado")
        }

    }

    removeVehicle(index: number): void {
        this.vehicles.removeAt(index);
    }
    //End array nuevo vehiculo


    formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }

    onAssignment() {
        const startDateRaw = this.assignmentForm.get('startDateAssignment')?.value;
        const endDateRaw = this.assignmentForm.get('endDateAssignment')?.value;

        //console.log("Valor crudo de startDateAssignment:", startDateRaw, "Tipo:", typeof startDateRaw);

        // Convertir a Date solo si es necesario
        const startDate = startDateRaw ? new Date(startDateRaw) : null;
        const endDate = endDateRaw ? new Date(endDateRaw) : null;

        // Validar si la conversión a Date es válida
        this.startDate = startDate instanceof Date && !isNaN(startDate.getTime()) ? this.formatDate(startDate) : '';
        this.endDate = endDate instanceof Date && !isNaN(endDate.getTime()) ? this.formatDate(endDate) : '';

        this.assignmentForm.patchValue({
            startDateAssignment: this.startDate,
            endDateAssignment: this.endDate
        });

        //console.log("Datos enviados al backend:", this.assignmentForm.value);
        //console.log("assignment_id:", this.assignment_id);

        this.assignmentLoanService.createLoan(this.assignment_id, this.assignmentForm.value).subscribe({
            next: (response: Assignments) => {
                //console.log('*** Assignment LOAN created ****:', response);
                this.messajeCreated("success", "Asignación Temporal Creada");
                this.recetAssignmentForm();
                this.recetEmployeeForm();
                setTimeout(() => { this.redirectSearchAssignment(); }, 2000);
            },
            error: error => {
                console.error("ERROR RESPONSE:", error);
                this.errorMessageAssignment = error.error.message;

                if (this.errorMessageAssignment) {
                    //console.log("MENSAJE ERROR:", this.errorMessageAssignment);
                    this.messajeError('error', 'error', this.errorMessageAssignment);
                }

                this.errorFromApi = error;
                if (this.errorFromApi) {
                    //console.log("ERROR FROM API:", this.errorFromApi);
                }
            }
        });
    }

    //END CONFIRMACIÓN DE ASIGNACIONES



    //CRUD GUEST
    loadAssignments() {
        this.assignmentLoanService.getAssignmentById(this.assignment_id).subscribe({
            next: (dataApi: any) => {
                //console.log("Respuesta de la API:", dataApi);

                // Verifica si `dataApi.data` tiene el ID de la asignación
                this.assignments = [dataApi.data];

                //console.log("ID de la asignación:", dataApi.data.id);

                this.errorMessageSearch = '';
            },
            error: error => {
                this.errorMessageSearch = error;
                //console.log("ERROR ON SEARCH GUEST", this.errorMessageSearch);
            }
        });
    }


    editAssignment(assignment: any): void {
        this.selectedAssignment = { ...assignment };
    }

    saveAssignment(): void {
        this.assignmentLoanService.updateAssignmentLoan(this.selectedAssignment.id, this.selectedAssignment).subscribe(() => {
            this.loadAssignments();
        });
    }

    removeAssignment(assignmentLoanId: string) {
        this.confirmationService.confirm({
            message: '¿Estás seguro de que deseas eliminar esta asignación temporal?',
            header: 'Confirmación de Eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sí',
            rejectLabel: 'No',
            rejectButtonStyleClass: 'p-button-text',
            accept: () => {
                this.assignmentLoanService.deleteAssignmentLoan(assignmentLoanId).subscribe({
                    next: (response: any) => {
                        //console.log('*** Asignación Invitado Eliminada ****:', response);
                        this.messajeCreated("success", "Asignación Temporal Eliminada");
                        setTimeout(() => { this.redirectSearchAssignment(); }, 1000);
                    },
                    error: (error) => {
                        this.errorMessageAssignment = error.error.message;
                        if (this.errorMessageAssignment) {
                            //console.log("MENSAJE ERROR", this.errorMessageAssignment);
                            this.messajeError('error', 'Error', this.errorMessageAssignment);
                        }
                    }
                });
            },
            reject: () => {
                //console.log("Eliminación cancelada");
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Cancelado',
                    detail: 'Se ha cancelado la eliminación',
                    life: 1000
                });
            }
        });
    }



    //END CRUD GUEST

    //CONFIRMACIÓN DE ASIGNACIONES
    confirmAssignment() {
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: '¿Desea crear una nueva Asignación temporal?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sí',
            rejectLabel: 'No',
            rejectButtonStyleClass: 'p-button-text',
            accept: () => {
                //this.messageService.add({ severity: 'info', summary: 'Confirmado', detail: 'Se ha creado una nueva asignación', life: 2000 });
                this.onAssignment();
            },
            reject: () => {
                this.messageService.add({ severity: 'info', summary: 'Acción cancelada', detail: 'Continua editando la asignación temporal.', life: 2000 });
            }
        });
    }

    //CONFIRMACIÓN ELIMINAR VEHÍCULO
    confirmDelVehicle(i: number) {
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: '¿Desea Eliminar Vehículo?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            acceptIcon: "none",
            rejectIcon: "none",
            acceptLabel: 'Sí',
            rejectLabel: 'No',
            rejectButtonStyleClass: "p-button-text",
            accept: () => {
                this.messageService.add({ severity: 'success', summary: 'Eliminado', detail: 'Se ha Eliminado el Vehículo', life: 1000 });

                this.removeVehicle(i);

            },
            reject: () => {
                this.messageService.add({ severity: 'info', summary: 'Continuar', detail: 'Asignación..', life: 2000 });
            }
        });
    }


    //CONFIRMACIÓN CANCELAR
    confirmCancel() {
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: '¿Desea Cancelar la Asignación temporal?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sí',
            rejectLabel: 'No',
            rejectButtonStyleClass: 'p-button-text',
            accept: () => {
                this.messageService.add({ severity: 'warn', summary: 'Cancelado', detail: 'Se ha cancelado el proceso de asignación temporal', life: 1000 });

                setTimeout(() => {
                    this.redirectSearchAssignment()
                }, 1000);

            },
            reject: () => {
                this.messageService.add({ severity: 'info', summary: 'Continuar', detail: 'Asignación temporal', life: 2000 });
            }
        });
    }


    //Acciones
    redirectSearchAssignment() {
        this.router.navigate(['assignment-employee']);
    }

    recetAssignmentForm() {
        this.assignmentForm.reset({
            //slotId: '',
            // parkingCardNumber: '',
            startDateAssignment: [],
            endDateAssignment: [],
            employee: {
                employeeCode: '',
                name: '',
                workplace: '',
                identifierDocument: '',
                company: '',
                department: '',
                subManagement: '',
                management1: '',
                management2: '',
                workSite: '',
                address: '',
                email: '',
                phone: '',
                vehicles: [],
            }
        });
    }

    recetEmployeeForm() {
        this.employeeForm.reset({
            id: ''
        });
    }

    messajeCreated(severity, message) {
        this.messageService.add({ severity: severity, summary: 'Éxito', detail: message, life: 1600 });
    }
    messajeError(alert: string, summary: string, error: string) {
        this.messageService.add({ severity: alert, summary: summary, detail: error, life: 16000 });
    }
    //End Acciones

    getAllVehicles() {
        this.catalogService.getVehicleTypeCatalog().subscribe({
            next: (response: any) => {
                this.vehicleCatalog = response.data;
                const activeVehicles = this.vehicleCatalog.filter(vehicle => vehicle.isActive);

                this.vehicleTypes = [...new Set(activeVehicles.map(vehicle => vehicle.name))];

                //console.log('Vehículos obtenidos:', this.vehicleCatalog);
                //console.log('Tipos de vehículos activos:', this.vehicleTypes);
            },
            error: error => {
                console.warn("Error al cargar los Vehículos")
            }

        })

    }


}
